import React, { useEffect, useState } from "react";
import LocationDropdown from "./LocationDropdown";
import TopicDropdown from "./TopicDropdown";
import * as analytics from "../util/Analytics/HomeAnalytics";
import {
    validateAndOpenUrl
} from "../util/constants";
const TopFilter = ({
    handleViewResultsclick,
    locationParameter,
    categoryParameter,
    topics,
    locations

}) => {
    const [location, setLocation] = useState(null);
    const [topic, setTopic] = useState(null);
    const [errorMessage, setErrorMessage] = useState(false);

    useEffect(() => {
        if (locationParameter && locationParameter.LocationAbbr) {
            analytics.selectLocation({
                locationCode: locationParameter.LocationAbbr,
            });
            setLocation(locationParameter);
        }
        if (categoryParameter && categoryParameter.TopicId) {
            analytics.selectCategory({ categoryCode: categoryParameter.TopicId });
            setTopic(categoryParameter);
        }
    }, [locationParameter, categoryParameter]);

    async function handleTopFilterSelections() {
        await setErrorMessage(false);
        await setTopic(null);
        await setLocation(null);
        await handleViewResultsclick({ location: null, topic: null });
    }

    function openIndicatorDefinitionsLink() {
        analytics.selectIndicatorDefinitions();
        validateAndOpenUrl(process.env.REACT_APP_CDI_INDICTOR_DEFINITIONS_URL, true);
    }

    async function handleViewResultsButtonClick() {
        if (
            location === null ||
            location.LocationAbbr === null ||
            topic === null ||
            topic.TopicId === null
        ) {
            setErrorMessage(true);
            return;
        } else {
            setErrorMessage(false);
            await handleViewResultsclick({ location: null, topic: null });
            await handleViewResultsclick({ location, topic });

            analytics.selectLocation({ locationCode: location.LocationAbbr });
            analytics.selectCategory({ categoryCode: topic.TopicId });
        }
    }



    const LocationAbbr =
        location && location.LocationAbbr ? location.LocationAbbr : null;
    const TopicId = topic && topic.TopicId ? topic.TopicId : null;

    const submitEnabled = LocationAbbr && TopicId ? true : false;
    //col-sm-12 col-md-12 col-lg-12 col-xl-6
    return (
        <div className="card bt-5 bt-cdc-blue ds-5 mb-3 d-print-none">
            <div className="card-body bg-light border rounded-bottom border-dark">
                <div className="row text-left align-items-center col-12">
                    <div className="col-md-6 col-lg-6 col-xl-4 topFilterSelector">
                        <LocationDropdown value={LocationAbbr} OnChange={setLocation} locations={locations} />
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-4 topFilterSelector">
                        <TopicDropdown value={TopicId} OnChange={setTopic} topics={topics} openIndicatorDefinitionsLink={openIndicatorDefinitionsLink} />
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-4">
                        <div className="row">
                            <div className="col-6 topFilterButtons">
                                <button
                                    id="view-result-button"
                                    className="btn btn-cdc-blue buttonMinWidth"
                                    onClick={handleViewResultsButtonClick}
                                    disabled={!submitEnabled}
                                >
                                    View Results
                                </button>
                            </div>
                            <div className="col-6 topFilterButtons">
                                <button className="btn btn-link" style={{ textDecoration: "underline" }} onClick={handleTopFilterSelections}>Clear</button>
                            </div>
                        </div>
                    </div>
                   

                </div>
                {errorMessage && (
                    <div className="col-12 error-message">
                        Please select a location and a category
                    </div>
                )}
            </div>
        </div>
    );
};

export default TopFilter;
